import { IAddFlatTourBookingRequest } from 'shared/repositories/newbuilding-flat-tour-booking/entities/Models/AddFlatTourBookingRequest';

import { Dispatch, IAppState } from '../../../shared/common/state';
import { ResponseError } from '../../../shared/errors';
import { transformUserBookingStatus } from '../../../shared/mappers/transformUserBookingStatus';
import {
  fetchAddFlatTourBooking,
  TAddFlatTourBookingResponse,
} from '../../../shared/repositories/newbuilding-flat-tour-booking/v1/add-flat-tour-booking';
import { setFlatViewOrder, toggleFlatTourBookingNotification } from '../../../shared/serp/state/flatTourBooking';

export function addFlatTourBooking(parameters: IAddFlatTourBookingRequest) {
  return async (dispatch: Dispatch, getState: () => IAppState): Promise<void> => {
    const { logger, httpApi } = getState();
    try {
      const response: TAddFlatTourBookingResponse = await fetchAddFlatTourBooking({
        httpApi,
        parameters,
        config: {
          requestConfig: {
            headers: [['Content-Type', 'application/json']],
          },
        },
      });

      if (response.statusCode !== 200) {
        throw new ResponseError({
          domain: 'addFlatTourBooking',
          message: '',
        });
      }

      const status = transformUserBookingStatus(response.response.userBookingStatus);

      dispatch(setFlatViewOrder(status));
      dispatch(toggleFlatTourBookingNotification(true));
    } catch (error) {
      logger.error(error, {
        domain: 'addFlatTourBooking',
      });

      throw error;
    }
  };
}
